// extracted by mini-css-extract-plugin
export default {"span":"uqoxkwLnFJySXKX0KkgI","text":"Oe92v7XV1pqWV2ZcbaXB","button":"mudqgnbWiHQOBL8Js9r8","danger":"nP8K2OqLBUnzM3zMCFst"};